"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualDriveAwayChoiceWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var DriveAwayChoiceComponent_1 = require("../../../components/annual/DriveAwayChoiceComponent");
var AnnualDriveAwayChoiceWidget = /** @class */ (function (_super) {
    __extends(AnnualDriveAwayChoiceWidget, _super);
    function AnnualDriveAwayChoiceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            var selectedValue = event.target.value;
            var isDriveAwayOnly = selectedValue === "driveAwayFiveDays";
            _this.props.onStateChange("driveAwayOnlyJourney", isDriveAwayOnly);
        };
        _this.state = {
            bgHeight: 0
        };
        _this.renderQuestions = _this.renderQuestions.bind(_this);
        return _this;
    }
    AnnualDriveAwayChoiceWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "cover-output no-shadow mb-0", children: [(0, jsx_runtime_1.jsx)("div", { className: "top-section", children: (0, jsx_runtime_1.jsx)(DriveAwayChoiceComponent_1.DriveAwayChoiceComponent, { interaction: this.props.interaction, onChange: this.handleOnChangeEvent }) }), this.renderQuestions()] }));
    };
    AnnualDriveAwayChoiceWidget.prototype.renderQuestions = function () {
        return (0, jsx_runtime_1.jsx)(plugin_journey_1.QuestionList, __assign({}, this.props, { questions: this.props.question.questions }));
    };
    return AnnualDriveAwayChoiceWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualDriveAwayChoiceWidget = AnnualDriveAwayChoiceWidget;
//# sourceMappingURL=AnnualDriveAwayChoiceWidget.js.map